import React from "react";
import Link from "gatsby";
import Button from "components/_ui/Button";
import styled from "@emotion/styled";
import dimensions from "styles/dimensions";
import { RichText } from "prismic-reactjs";
import PropTypes from "prop-types";

const AboutContainer = styled("section")`
    position: relative;
    zoom: 1;
    margin-top: 3em;
    display: block;

    @media(min-width: ${dimensions.minwidthTablet}px) {
      display: flex;
      align-items: flex-start;
    }
`

const ImageContainer = styled("div")`
    flex: 0 0 auto;
    margin-left: -6.25%;
    width: 62.5%;

    @media(min-width: ${dimensions.minwidthTablet}px) {
        margin-left: -12.5%;
        width: 43.75%;
    }

    @media(min-width: ${dimensions.minwidthDesktop}px) {
        margin-left: -6.25%;
    }
`

const ImageWrapper = styled("div")`
    position: relative;
    img {
      width: 100%;
      display: block;
      max-width: 100%;
    }
`

const AboutCopyWrapper = styled("div")`
    margin-top: 2.125em;
    padding: 0 12.5%;

    @media(min-width: ${dimensions.minwidthTablet}px) {
      width: 68.75%;
      padding-left: 6.25%;
      margin-top: 0;
      flex: 0 0 auto;
    }

    @media(min-width: ${dimensions.minwidthDesktop}px) {
      width: 62.5%;
      padding: 0 12.5%;
    }
`

const AboutText = styled("div")`

    h2 {
        margin: 0;
        color: #303030;
        font-size: calc(1.25rem + 1.875vw - 6px);
        line-height: calc(1.5rem + 2vw - 6.4px);
        /* font-weight: 500; */
        padding-bottom: 2.5vw;

        @media(min-width: ${dimensions.minwidthTablet}px) {
            padding-bottom: 2.0833vw;
        }

        @media(min-width: ${dimensions.minwidthDesktop}px) {
            padding-bottom: 1.6667vw;
        }
    }

    p {
      margin: 1.25em 0;
      color: #8f8f8f;
      font-size: calc(.75rem + .5vw - 1.6px);
      line-height: calc(1.125rem + .625vw - 2px);
      font-weight: 400;
    }
`

const AboutButton = styled("div")`

    margin-top: 24px;

    @media(min-width: ${dimensions.minwidthTablet}px) {
      margin-top: 40px;
    }

    @media(min-width: ${dimensions.minwidthDesktop}px) {
      margin-top: 80px;
    }

    a {
      display: inline-block;
    }

    button {
      

      .button-init {
        
      }
    }
`

const About = ({ headline, copy, image, cta_text, cta_target  }) => (
<AboutContainer>
  <ImageContainer
    data-sal="slide-right"
    data-sal-duration="500"
    data-sal-delay="150"
    data-sal-easing="ease-out"
  >
    <ImageWrapper>
      <img src={image.url} />
    </ImageWrapper>
  </ImageContainer>
  <AboutCopyWrapper>
    <AboutText
      data-sal="slide-left"
      data-sal-duration="500"
      data-sal-delay="150"
      data-sal-easing="ease-out"
    >
        {RichText.render(headline)}
        {RichText.render(copy)}
    </AboutText>
    <AboutButton
      data-sal="fade"
      data-sal-duration="500"
      data-sal-delay="150"
      data-sal-easing="ease-out"
    >
      <a href="about">
        <Button className="button-init">
            <span>{RichText.asText(cta_text)}</span>
        </Button>
      </a>
    </AboutButton>
  </AboutCopyWrapper>
</AboutContainer>
)

export default About;

About.propTypes = {
    headline: PropTypes.array.isRequired,
    copy: PropTypes.array.isRequired,
    image: PropTypes.array.isRequired,
    cta_text: PropTypes.array.isRequired,
    cta_target: PropTypes.array.isRequired,
};